import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'

const request = axios.create({
  baseURL: import.meta.env.DEV
    ? '/api'
    : (import.meta.env.VITE_API_BASE_URL || ''),
  timeout: 10000,
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.token) {
      config.headers['Authorization'] = `Bearer ${authStore.token}`
    }
    config.headers['app-key'] = import.meta.env.VITE_APP_KEY
    return config
  },
  (error) => Promise.reject(error)
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code != 200) {
      // 401 未登录 / token 失效
      if (res.code == 401) {
        const authStore = useAuthStore()
        authStore.clearLocal()
        ElMessage.error(res.message || '登录已失效，请重新登录')
        router.push('/login')
      } else if (res.code === 403) {
        // 403 未审核通过 / 无权限，仅提示，不强制跳转
        ElMessage.warning(res.message || '当前账号无权限访问该接口')
      } else {
        ElMessage.error(res.message || '请求失败')
      }
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  (error) => {
    // HTTP 错误（4xx/5xx）
    const status = error.response?.status
    const msg = error.response?.data?.message || error.message
    if (status == 401) {
      const authStore = useAuthStore()
      authStore.clearLocal()
      ElMessage.error('登录已失效，请重新登录')
      router.push('/login')
    } else {
      ElMessage.error(msg || '网络错误')
    }
    return Promise.reject(error)
  }
)

export default request
